import '../../../../../packages/neb-lit-components/src/components/neb-popup-header';
import '../../../misc/neb-notes-column';
import { css, html } from 'lit';

import Overlay from '../../../../../packages/neb-lit-components/src/components/overlays/neb-overlay';
import { store } from '../../../../../packages/neb-redux/neb-redux-store';
import { BILLING_NOTE_TYPES } from '../../../../../packages/neb-utils/constants';
import {
  deleteBillingNotes,
  getBillingNotesByInvoiceId,
  upsertBillingNotes,
} from '../../../../api-clients/billing-note';
import { openError, openSuccess } from '../../../../store';
import {
  CSS_SPACING,
  CSS_COLOR_GREY_2,
  CSS_COLOR_GREY_4,
} from '../../../../styles/index';

export const ELEMENTS = {
  header: { id: 'header' },
  notesContainer: { id: 'notes-container' },
};

class NebOverlayInvoiceNotes extends Overlay {
  static get properties() {
    return {
      model: { type: Object },
      __invoiceNotesModel: { type: Object },
      __chargeNotesModel: { type: Object },
      __claimNotesModel: { type: Object },
      __expandedNotes: { type: Object },
    };
  }

  static get styles() {
    return [
      super.styles,

      css`
        .header {
          padding: ${CSS_SPACING};
          border-bottom: 1px solid ${CSS_COLOR_GREY_2};
        }

        .content {
          width: 100%;
        }

        .notes-container {
          display: flex;
          flex-direction: row;
          gap: ${CSS_SPACING};
          height: 100%;
          padding: ${CSS_SPACING};
          overflow-y: auto;
          background: ${CSS_COLOR_GREY_4};
        }

        neb-notes-column {
          flex: 1;
          overflow: auto;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.initState();
    this.initHandlers();
  }

  initState() {
    super.initState();
    this.model = {
      invoiceId: '',
    };

    this.__invoiceNotesModel = { noteGroups: [] };
    this.__chargeNotesModel = { noteGroups: [] };
    this.__claimNotesModel = { noteGroups: [] };
  }

  initHandlers() {
    super.initHandlers();

    this.handlers = {
      ...this.handlers,

      saveNote: async saveBody => {
        try {
          if (saveBody.entries.length === 0) {
            await deleteBillingNotes(saveBody);
            store.dispatch(openSuccess('Note deleted successfully'));
          } else {
            await upsertBillingNotes(saveBody, true);
            store.dispatch(openSuccess('Note saved successfully'));
          }

          await this.__fetchNotes();
        } catch (error) {
          store.dispatch(openError('An error occurred when saving the note'));
        }
      },

      fetchNotes: async () => {
        await this.__fetchNotes();
      },
    };
  }

  async updated(changedProps) {
    if (changedProps.has('model') && this.model.invoiceId) {
      await this.__fetchNotes();
    }
  }

  async __fetchNotes() {
    const result = await getBillingNotesByInvoiceId(this.model.invoiceId);

    this.__invoiceNotesModel = { noteGroups: [result.invoice] };
    this.__chargeNotesModel = { noteGroups: result.charges };
    this.__claimNotesModel = { noteGroups: result.claims };
  }

  renderContent() {
    return html`
      <neb-popup-header
        id="${ELEMENTS.header.id}"
        class="header"
        title="Notes"
        showCancelButton
        .onCancel="${this.handlers.dismiss}"
      ></neb-popup-header>

      <div class="notes-container" id="${ELEMENTS.notesContainer.id}">
        <neb-notes-column
          .model="${this.__invoiceNotesModel}"
          .onSave="${this.handlers.saveNote}"
          .onFetchNotes="${this.handlers.fetchNotes}"
          .onChangeDirty="${this.handlers.dirty}"
          .title="${'Invoice Notes'}"
          .type="${BILLING_NOTE_TYPES.INVOICE}"
          .includeAddNoteButton=${true}
          .includeNoteActionButtons=${true}
        ></neb-notes-column>

        <neb-notes-column
          .model="${this.__chargeNotesModel}"
          .onFetchNotes="${this.handlers.fetchNotes}"
          .title="${'Charge Notes'}"
          .type="${BILLING_NOTE_TYPES.CHARGE}"
          .includeEditNotesButton=${true}
        ></neb-notes-column>

        <neb-notes-column
          .model="${this.__claimNotesModel}"
          .onFetchNotes="${this.handlers.fetchNotes}"
          .title="${'Claim Notes'}"
          .type="${BILLING_NOTE_TYPES.CLAIM}"
          .includeEditNotesButton=${true}
        ></neb-notes-column>
      </div>
    `;
  }
}

customElements.define('neb-overlay-invoice-notes', NebOverlayInvoiceNotes);
